module.exports = __webpack_public_path__ + "img/new_company.1a83120c.svg";